import axios from 'axios';
import { API_URL } from '../config/api';

const FIFO_API = `${API_URL}/fifo`;

// Get headers with auth token is handled by AuthContext axios interceptor generally,
// but let's assume it's set globally.

export const fifoService = {
    // Products
    searchProducts: async (params) => {
        const response = await axios.get(`${FIFO_API}/products`, { params });
        return response.data;
    },

    getInventoryRefreshStatus: async () => {
        const response = await axios.get(`${FIFO_API}/inventory/refresh-status`);
        return response.data;
    },

    refreshInventoryData: async () => {
        const response = await axios.post(`${FIFO_API}/inventory/refresh`);
        return response.data;
    },

    // Requests
    createRequest: async (data) => {
        const response = await axios.post(`${FIFO_API}/requests`, data);
        return response.data;
    },

    getPendingRequests: async () => {
        const response = await axios.get(`${FIFO_API}/requests`);
        return response.data;
    },

    getAllRequests: async () => {
        const response = await axios.get(`${FIFO_API}/requests/all`);
        return response.data;
    },

    getEditableRequest: async (documentId) => {
        const response = await axios.get(`${FIFO_API}/requests/${documentId}/edit`);
        return response.data;
    },

    updateRequest: async (documentId, data) => {
        const response = await axios.put(`${FIFO_API}/requests/${documentId}/edit`, data);
        return response.data;
    },

    cancelRequest: async (documentId) => {
        const response = await axios.put(`${FIFO_API}/requests/${documentId}/cancel`);
        return response.data;
    },

    // Inventory logic
    updateStatus: async (documentId, status) => {
        const response = await axios.put(`${FIFO_API}/requests/${documentId}/status`, { status });
        return response.data;
    },

    acceptSerial: async (snNumber) => {
        // sn_number goes in the body, not the URL — every serial contains a
        // literal "/" (e.g. "S/N.xxxxx"), and Plesk's Apache reverse proxy
        // 404s on an encoded slash in a path segment before it reaches Node.
        const response = await axios.put(`${FIFO_API}/requests/serial/accept`, { sn_number: snNumber });
        return response.data;
    },

    getInventoryOutRequests: async () => {
        const response = await axios.get(`${FIFO_API}/requests/inventory-out`);
        return response.data;
    },

    // QC logic
    getQcRequests: async () => {
        const response = await axios.get(`${FIFO_API}/requests/qcm`);
        return response.data;
    },

    getQcRequestDetail: async (documentId) => {
        const response = await axios.get(`${FIFO_API}/requests/qcm/${encodeURIComponent(documentId)}`);
        return response.data;
    },

    getQcHistory: async () => {
        const response = await axios.get(`${FIFO_API}/requests/qcm/history`);
        return response.data;
    },

    updateQcStatus: async (snNumber, status, remark) => {
        // sn_number goes in the body, not the URL — same reason as
        // acceptSerial above (literal "/" in every serial 404s at the proxy).
        const response = await axios.put(`${FIFO_API}/requests/serial/qc-status`, {
            sn_number: snNumber,
            status,
            remark
        });
        return response.data;
    },

    // Generate PDF
    downloadPDF: async (documentId) => {
        const response = await axios.get(`${FIFO_API}/requests/${documentId}/pdf`, {
            responseType: 'blob'
        });
        return response.data;
    }
};
